export const state = () => ({
})

export const mutations = {
}

export const actions = {
  postQuestion ({ commit, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const { fullName, email, text } = data

      const payload = {
        FullName: fullName,
        Email: email,
        Message: text
      }

      this.$axios.post('/network/contact', payload, {})
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  async getFaq ({ commit }) {
    return await this.$axios.get('/public/yda/faq')
  }
}
